import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';
import FormFieldsCompact from '../form/fieldsCompact';

import commissionStore from '../../stores/commission';

@observer
class EditUserCommission extends Component {
    constructor(props) {
        super(props);

        // Build a dedicated section containing ONLY the two commission fields.
        // We clone the field definitions and strip `isAdminField` so that a
        // clinic customerAdmin (who is NOT a super-admin) can see and edit them.
        // The originals in fields.js stay untouched (still admin-only in the
        // regular user-edit view).
        const userSections = fields.get('user') || [];
        const allFields = userSections.reduce((acc, section) => acc.concat(section.fields || []), []);
        const commissionFields = ['commissionRate', 'commissionMva']
            .map(name => allFields.find(f => f.name === name))
            .filter(Boolean)
            .map(f => ({ ...f, isAdminField: false }));

        this.state = {
            sections: [
                {
                    name: <Text id='dyrejournal.commission.section'>Commission</Text>,
                    key: 'Commission',
                    fields: commissionFields,
                },
            ],
        };
    }

    componentDidMount() {
        const { member, user } = this.props;
        const selectedUser = member || user;
        if (selectedUser) {
            commissionStore.setUser(selectedUser);
        }
    }

    render() {
        const { drawerLevel } = this.props;
        const { sections } = this.state;
        const { user = {} } = commissionStore;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <i class='fa-duotone fa-percent me-2' />
                        <Text id='dyrejournal.commission.edit'>Edit commission</Text>
                        {(user.firstname || user.lastname) && <>
                            {' '}<span class='text-body-secondary'>{`${user.firstname || ''} ${user.lastname || ''}`.trim()}</span>
                        </>}
                    </div>
                    <div class='d-flex flex-column justify-content-start h-100' style='padding: 0 8px;'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            fields={['commissionRate', 'commissionMva']}
                            holdingStore={commissionStore}
                            objectName='user'
                            isNew={false}
                            drawerLevel={drawerLevel}
                            /* isAdmin only picks the save path in FormFieldsCompact: true routes
                                through LocalModel.adminUpdate (PATCH /api/users/admin/:id, super-admin
                                only), false through commissionStore.saveField (PATCH /api/users/commission,
                                which accepts clinic admins). Field visibility uses userStore.isAdmin, not
                                this prop. Must stay false so clinic admins can save. */
                            isAdmin={false}
                            hideAdmin={true}
                            hideFilterToolbar={true}
                        />
                        <div class='px-3 pt-2 text-body-secondary'>
                            <small>
                                <i class='fa-duotone fa-circle-info me-1' />
                                <Text id='dyrejournal.commission.autosave-hint'>Changes are saved automatically</Text>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EditUserCommission;
